import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useSetAtom } from 'jotai'
import { LOOKUP_URL_PARAM } from 'src/utils/constants'
import { SearchOptions, useSearch } from 'src/views/map-explorer/sidebar/search/use-search'

import * as searchAtoms from 'src/v2/state/map-explorer/search'

export function useSearchFromUrlParam(options: SearchOptions) {
  const router = useRouter()
  const setQuery = useSetAtom(searchAtoms.searchQuery)
  const { search } = useSearch(options)

  useEffect(() => {
    if (router.query[LOOKUP_URL_PARAM]) {
      const decoded = decodeURIComponent(router.query[LOOKUP_URL_PARAM] as string)
      setQuery(decoded)
      void router.replace(router.pathname, undefined, { shallow: true })
      void search(decoded)
    }
  }, [])
}
